import React from "react";

const Fallback = () => (
    <div
        style={{
            width: "100%",
            height: 140,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            background:
                "linear-gradient(135deg, rgba(232,253,83,.15), rgba(10,61,53,.2))",
        }}
    >
        <span style={{ opacity: 0.8 }}>Bild folgt</span>
    </div>
);

export default function GridCard({ title, subtitle, img, onClick }) {
    const [err, setErr] = React.useState(false);
    return (
        <button className="grid-card" onClick={onClick} type="button">
            {err ? (
                <Fallback />
            ) : (
                <img
                    src={img}
                    alt={title}
                    onError={() => setErr(true)}
                    loading="lazy"
                />
            )}
            <div className="grid-card__info">
                <div className="grid-card__title">{title}</div>
                {/* Orbitron-Akzent über zusätzliche Klasse 'orbitron' */}
                <div className={`grid-card__sub ${subtitle ? "orbitron" : ""}`}>
                    {subtitle}
                </div>
            </div>
        </button>
    );
}
